import React from 'react'
import { Box, FormControl, FormLabel, TextField } from '@mui/material'
import { useAppDispatch, useAppSelect } from 'src/hooks/useRedux'

import { setReportPayload } from '../../ducks/report.reducer'

const Comment: React.FC = () => {
  const dispatch = useAppDispatch()
  const { payload, loading } = useAppSelect((state) => state.reports)

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setReportPayload({ ...payload, message: e.target.value }))
  }

  return (
    <FormControl sx={{ width: '100%' }}>
      <FormLabel>
        Comment{' '}
        <Box component="span" sx={{ color: 'bw.red' }}>
          *
        </Box>
      </FormLabel>
      <TextField
        value={payload.message}
        onChange={onChange}
        disabled={loading}
        multiline
        minRows={4}
        placeholder="Comment *"
        required
      />
    </FormControl>
  )
}

export default Comment
